import React from 'react';
import OldFilterModal from '../../../VentoryUI/components/common/FilterModal';
import { BaseFilter } from '../../../VentoryUI/components/filters/common/BaseFilter';
import { FilterProps } from '../../../VentoryUI/components/filters/common/filter.util';

interface FilterModalProps<T> {
  open: boolean;
  setOpen: (open: boolean) => void;
  onClose: () => void;
  filter: BaseFilter<T>;
  filterProps: FilterProps;
  setFilterProps: (filter: FilterProps) => void;
}

export default function FilterModal<T>(props: FilterModalProps<T>) {
  return <OldFilterModal {...props} />;
}
